// @ts-nocheck
import React from 'react'
import styled from 'styled-components'
import IconComponent from 'themes/IconComponent'
import ButtonBase from 'components/common/ButtonBase'
import { useRouter } from 'next/router'

// assets
const ConfirmationIcon = (props) => <IconComponent asset="/icons/confirmed.svg" {...props} />

const ConfirmationContainer = styled.div`
	@media (min-width: 577px) {
		width: 580px;
		//height: 495px;
		margin: 82px auto 20vh auto;
		padding: 71px 0 63px 0;
		box-shadow: 0 4px 9px rgba(0, 0, 0, 0.15);
	}
	margin-top: 52px;
	margin-bottom: 10px;
	background-color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`

const StyledConfirmationText = styled.h1`
	font-family: Oswald, 'Roboto', 'Helvetica', 'Arial', sans-serif;
	font-weight: 700;
	font-size: 34px;
	max-width: 335px;
	text-align: center;
	line-height: 36px;
	margin-bottom: 27px;
	@media (max-width: 576px) {
		margin-bottom: 21px;
	}
`

const StyledConfirmationIcon = styled(ConfirmationIcon)`
	margin-bottom: 21px;
	@media (max-width: 576px) {
		margin-bottom: 40px;
	}
`

const ContactUsConfirmation = ({ lang, confirmationText, eCommerce, confirmationBtnText }) => {
	const router = useRouter()

	const clickHandler = () => {
		if (eCommerce) {
			router.push('/home')
		} else {
			const url = `${window.location.protocol}//${window.location.host}/home`
			window.location.href = url
		}
	}
	return (
		<ConfirmationContainer data-testid="contact-us-confirmation-container">
			<StyledConfirmationIcon />
			<StyledConfirmationText>{confirmationText}</StyledConfirmationText>
			<ButtonBase $size="big" onClick={clickHandler} fullWidth={false} data-testid="back-to-homepage-button">
				{confirmationBtnText}
			</ButtonBase>
		</ConfirmationContainer>
	)
}

export default ContactUsConfirmation
